/**
 * Auth Module - v2/Auth Worker Version
 *
 * Provides authentication functionality using the Auth Worker.
 *
 * Usage:
 *   import { useAuth, AuthProvider, authClient } from '@/lib/auth';
 *
 *   // In a component:
 *   const { user, signIn, signOut, isAuthenticated } = useAuth();
 *
 *   // For API requests:
 *   const headers = authClient.getAuthHeader();
 */

export { AuthProvider, useAuth } from "./AuthContext";
export { authClient, createAuthClient, type AuthUser, type AuthSession, type AuthError, type AuthResult } from "./client";
